import { render } from "./donutchart.vue?vue&type=template&id=0c1052c6&scoped=true"
import script from "./donutchart.vue?vue&type=script&lang=js"
export * from "./donutchart.vue?vue&type=script&lang=js"

import "./donutchart.vue?vue&type=style&index=0&id=0c1052c6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c1052c6"]])

export default __exports__